import { render, staticRenderFns } from "./bulk_add_usaw.vue?vue&type=template&id=21bc02b7&scoped=true&"
import script from "./bulk_add_usaw.vue?vue&type=script&lang=js&"
export * from "./bulk_add_usaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc02b7",
  null
  
)

export default component.exports